import { parsePhoneNumberFromString, type CountryCode } from 'libphonenumber-js';

// Normalización y copys de la verificación de celular (anti-abuso del trial).
// Ver docs/superpowers/specs/2026-08-31-verificacion-celular-design.md.

export interface PaisTelefono {
  iso: CountryCode;
  nombre: string;
  prefijo: string;
}

// Mismos países que el selector del onboarding (OnboardingSelects.tsx), con ISO y
// prefijo. Argentina primero: es el default.
export const PAISES_TELEFONO: PaisTelefono[] = [
  { iso: 'AR', nombre: 'Argentina', prefijo: '+54' },
  { iso: 'BO', nombre: 'Bolivia', prefijo: '+591' },
  { iso: 'BR', nombre: 'Brasil', prefijo: '+55' },
  { iso: 'CL', nombre: 'Chile', prefijo: '+56' },
  { iso: 'CO', nombre: 'Colombia', prefijo: '+57' },
  { iso: 'EC', nombre: 'Ecuador', prefijo: '+593' },
  { iso: 'PY', nombre: 'Paraguay', prefijo: '+595' },
  { iso: 'PE', nombre: 'Perú', prefijo: '+51' },
  { iso: 'UY', nombre: 'Uruguay', prefijo: '+598' },
  { iso: 'VE', nombre: 'Venezuela', prefijo: '+58' },
  { iso: 'MX', nombre: 'México', prefijo: '+52' },
  { iso: 'US', nombre: 'Estados Unidos', prefijo: '+1' },
  { iso: 'ES', nombre: 'España', prefijo: '+34' },
];

/**
 * Normaliza a E.164 (con "+") el número tal como lo escribe el usuario. `null` si
 * no es un número válido para ese país.
 *
 * Caso argentino: el E.164 de un MÓVIL lleva "9" entre el 54 y el código de área
 * (+54 9 11 ...), pero nadie escribe su número así — se dicta "11 5555-1234". Acá
 * se verifica un CELULAR (tiene que recibir SMS), así que si falta el 9 se inserta.
 */
export function normalizarCelular(input: string, pais: CountryCode): string | null {
  const parsed = parsePhoneNumberFromString(input, pais);
  if (!parsed || !parsed.isValid()) return null;
  const e164: string = parsed.number;
  if (e164.startsWith('+54') && !e164.startsWith('+549')) {
    return `+549${e164.slice(3)}`;
  }
  return e164;
}

/**
 * Copys en castellano para los errores de Supabase Auth en este flujo. El `code`
 * existe en supabase-js v2 moderno; por las dudas también se mira el status (429).
 * GoTrue usa `otp_expired` tanto para código vencido como para código incorrecto.
 */
export function mensajeErrorVerificacion(
  err: { code?: string; status?: number } | null | undefined,
): string {
  const code = err?.code ?? '';
  if (code === 'phone_exists') return 'Ese número ya está en uso en otra cuenta.';
  if (code === 'otp_expired') return 'El código venció o no es correcto. Pedí uno nuevo.';
  if (code === 'sms_send_failed') return 'No pudimos enviarte el SMS. Probá de nuevo en un rato.';
  if (code === 'over_sms_send_rate_limit' || err?.status === 429) {
    return 'Demasiados intentos. Esperá un minuto y probá de nuevo.';
  }
  if (code === 'validation_failed') return 'El número no parece válido. Revisalo.';
  return 'No se pudo completar la verificación. Probá de nuevo.';
}
